import { useSupervisionStore } from "@/store/modules/supervision";

const checkSupervisionAccessMiddleware = () => {
  return async (to, from, next) => {
    try {
      const supervisionStore = useSupervisionStore();
      const missionId = to.params.missionId;

      if (!missionId) {
        return next();
      }

      const activeSupervision = await supervisionStore.checkActiveSupervision(missionId);

      to.meta.activeSupervision = activeSupervision;
      to.meta.showNotAccessibleModal =
        activeSupervision?.hasActiveSupervision && !activeSupervision?.isCurrentUserReviewer;

      return next();
    } catch (err) {
      console.error("Error checking supervision:", err);
      return next();
    }
  };
};

export default checkSupervisionAccessMiddleware;
